import { render, staticRenderFns } from "./ProfilePenalties.vue?vue&type=template&id=0eb72392&"
import script from "./ProfilePenalties.vue?vue&type=script&lang=js&"
export * from "./ProfilePenalties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports